export default "__VITE_ASSET__C7Mf6I41__"